module.exports = __webpack_public_path__ + "static/media/husite.c1d7ee27.jpg";